<template>
    <div class="row">
        <div class="col-10">
            <settings-property :label="resource('JourneyComposer_BrickSettingsAudienceFilter_ConditionFieldType_DisplayName')">
                <template #input="{id}">
                    <v-select
                        class="form-control"
                        v-model="typeModel"

                        :input-id="id"
                        :options="fieldTypes"
                        :clearable="false"
                        :disabled="!canWrite || !fieldTypes.length"
                    />
                </template>
            </settings-property>
        </div>
        <div class="col-2">
            <button class="btn btn-outline-danger" @click="$emit('delete')" :disabled="!canWrite">
                <i class="fa fa-trash"></i>
            </button>
        </div>
        <div class="col-10">
            <settings-property :label="resource('JourneyComposer_BrickSettingsAudienceFilter_ConditionFieldValue_DisplayName')">
                <template #input="{id}">
                    <input v-if="!isDropdown"
                        :key="id"

                        type="text"
                        class="form-control"
                        :input-id="id"
                        v-model="valueModel"
                           
                        :disabled="!canWrite"
                    />
                    <v-select v-else
                        class="form-control"
                        v-model="valueModel"
                        
                        :key="id"
                        :input-id="id"
                        :options="dropdownValues"
                        
                        :disabled="!canWrite || dropdownValues.length === 0"
                        searchable
                        filterable
                    />
                </template>
            </settings-property>
        </div>
    </div>
</template>

<script>
    import resourceMixin from "@core/Util/Mixins/resources";
    import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';

    import VSelect from 'vue-select';
    import SettingsProperty from "../SettingsProperty";

    export default {
        name: 'audience-filter-brick-condition-field',
        mixins: [resourceMixin, permissionsMixin],
        components: {
            VSelect, 
            SettingsProperty
        },
        computed: {
            /**
             * Get the dropdown values for the current selected dropdown type.
             * Default to empty array.
             */
            dropdownValues() {
                const values = [];

                if(!this.isDropdown) return values;

                return this.fields.filter(field => field.type === this.typeModel.id)
                    .map(field => {
                        return {
                            id: field.id,
                            label: field.value
                        };
                    });
            },
            isDropdown() {
                if(!this.typeModel)
                    return false;

                return this.fields.find(f => f.type === this.typeModel.id).isDropDown;
            },
            /**
             * Get default value for the current selected type.
             * Default to undefined.
             */
            defaultValue() {
                if(!this.typeModel) return undefined;
                const defaultValue = this.fields.find(f => f.type === this.typeModel.id && f.isDefault);
                
                if(!defaultValue) return undefined;
                return this.isDropdown ? { id: defaultValue.id, label: defaultValue.value } : defaultValue.value;
            },
            /**
             * Return unique field types for our type dropdown
             */
            fieldTypes() {
                const unique = [];
                const all = this.fields.map(f => {
                    return {
                        id: f.type,
                        label: f.label
                    }
                });

                all.forEach((value) => {
                    if(!unique.find(u => u.id.toLowerCase() === value.id.toLowerCase())) {
                        unique.push(value);
                    }
                });

                return unique;
            },
            typeModel: {
                get() {
                    const vm = this;
                    const selected = vm.fieldTypes.find(t => t.id === vm.type);
                    return selected ? selected : undefined;
                },
                set(field){
                    this.$emit('update:type', field ? field.id : undefined);
                }
            },
            /**
             * Keep track of our selected value for value dropdown.
             */
            selectedValue() {
                if(!this.isDropdown || !this.value) return undefined;

                const selected = this.fields.find(field => field.id.toLowerCase() === this.value.toLowerCase());
                return selected ? { id: selected.id.toLowerCase(), label: selected.value } : undefined;
            },
            /**
             * Value is either a dropdown value id or a value string.
             */
            valueModel: {
                get(){
                    return this.isDropdown ? this.selectedValue : this.value;
                },
                set(value) {
                    this.$emit('update:value', this.isDropdown ? value ? value.id : undefined : value);
                }
            }
        },
        watch: {
            /**
             * Load default value when changing type.
             */
            type(value) {
                this.valueModel = this.defaultValue;
            }
        },
        props: {
            type: String,
            value: String,
            fields: {
                type: Array,
                required: true
            }
        }
    }
</script>

<style scoped>
    .btn .fa {
        margin-right: 0;
    }
</style>